import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './Layout';

// Import Pages
import Home from './Pages/Home';
import AreaClienti from './Pages/AreaClienti';
import ChiSiamo from './Pages/ChiSiamo';
import Contatti from './Pages/Contatti';
import FAQPage from './Pages/FAQPage';
import Manutenzione from './Pages/Manutenzione';
import Riparazioni from './Pages/Riparazioni';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import CookiePolicy from './Pages/CookiePolicy';
import Login from './Pages/Login';
import Register from './Pages/Register';
import EmailVerified from './Pages/EmailVerified';
import NotFound from './Pages/NotFound';
import AdminDashboard from './Pages/AdminDashboard';

import ScrollToTop from './Components/ScrollToTop';

import { base44 } from '@/api/base44Client';
import { useEffect } from 'react';

function App() {
  // Auto-logout logic
  useEffect(() => {
    let timeout;
    const INACTIVITY_LIMIT = 30 * 60 * 1000; // 30 minutes

    const resetTimer = () => {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        base44.auth.isAuthenticated().then(isAuth => {
          if (isAuth) {
            console.log('Auto-logout due to inactivity');
            base44.auth.logout();
          }
        });
      }, INACTIVITY_LIMIT);
    };

    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => document.addEventListener(event, resetTimer));

    resetTimer(); // Initialize timer

    return () => {
      if (timeout) clearTimeout(timeout);
      events.forEach(event => document.removeEventListener(event, resetTimer));
    };
  }, []);

  return (
    <Layout currentPageName="Home">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/area-clienti" element={<AreaClienti />} />
        <Route path="/chi-siamo" element={<ChiSiamo />} />
        <Route path="/contatti" element={<Contatti />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/manutenzione" element={<Manutenzione />} />
        <Route path="/riparazioni" element={<Riparazioni />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/email-verified" element={<EmailVerified />} />
        <Route path="/admin" element={<AdminDashboard />} />

        {/* Fallback for undefined routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

export default App;
